(function () {
    'use strict';
    $(document).ready(function () {

        $('.datepicker').datepicker($.datepicker.regional[ "pl" ] );

    });
}(jQuery));